import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Box } from '@mui/material'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import MeetingForm from 'components/organisms/forms/MeetingForm'
import MeetingProtocolForm from 'components/organisms/forms/MeetingProtocolForm'
import Tabs from 'components/organisms/tabs/Tabs'

import { crudActionsMap } from 'utils/helpers'

const MeetingCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.meetings')} / ${t('common.' + action)}`} />
      <PageBody>
        <Box sx={{ marginTop: '0rem' }}>
          <Tabs tabKey='meeting'>
            <MeetingForm
              tabText={`${t('meetings.meeting')}`}
              tabKey='meeting'
              action={action}
              id={id}
              viewOnly={viewOnly}
            />
            {id &&
            <MeetingProtocolForm
              tabText={`${t('meetings.meeting-protocol')}`}
              tabKey='protocol'
              action={action}
              id={id}
              viewOnly={viewOnly}
            />
            }
          </Tabs>
        </Box>
      </PageBody>
    </>
  )
}
export default MeetingCrudPage
